module.exports = __webpack_public_path__ + "img/clock.f60cc3c2.svg";